module.exports = __webpack_public_path__ + "static/sport/pcBg.3465a06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/pcBg.png
// module id = OUGd
// module chunks = 0